import React, { useEffect, useRef, useState } from 'react'
import Cookies from 'js-cookie'
import { Container, Row, Col } from 'react-bootstrap'
import Link from 'next/link'
import styles from './Footer.module.scss'
import classNames from 'classnames'
import getConfig from 'next/config'
import { useRouter } from 'next/router'
import { correctPTlocale } from '@srca-b2b/kp5-ui-common/utils/helpers'
import CookieSettingModal from '../CookieSettingModal/CookieSettingModal'
import { useTranslation } from 'next-i18next'

const { publicRuntimeConfig } = getConfig()

const languageList = [
  { value: 'de', label: 'Deutsch' },
  { value: 'en', label: 'English' },
  { value: 'es-419', label: 'Español AL' },
  { value: 'fr', label: 'Français' },
  { value: 'ko', label: '한국어' },
  { value: 'it', label: 'Italiano' },
  { value: 'pt-br', label: 'Português' }
]

const Footer = () => {
  const router = useRouter()
  const localizedPages = ['/federated-id/login', '/register/[[...productParam]]']
  const priorRegistrationLang = Cookies.get('registrationLang')
  const currentLang = priorRegistrationLang || router.locale
  const [selectedLanguage, setSelectedLanguage] = useState(currentLang || 'en')
  const [showCookiesModal, setShowCookiesModal] = useState(false)

  const isOnLocalizedPage = localizedPages.includes(router.pathname)
  const [countryRegion, setCountryRegion] = useState(null)
  const { t } = useTranslation('common')

  useEffect(() => {
    if (localStorage.getItem('countryRegion')) {
      setCountryRegion(localStorage.getItem('countryRegion'))
    }

    changeSelectWidth()
  }, [])

  // for even spacing of footer elements see KP5-2822
  const languageSelectorRef = useRef(null)
  const changeSelectWidth = () => {
    if (languageSelectorRef.current) {
      const text = languageSelectorRef.current.querySelector('option:checked').text
      const span = document.createElement('span')
      span.innerHTML = text
      document.body.append(span)
      const width = span.getBoundingClientRect().width
      languageSelectorRef.current.style.width = `${width}px`
      span.remove()
    }
  }

  const onChangeLanguage = (locale) => {
    setSelectedLanguage(locale)
    Cookies.set('registrationLang', correctPTlocale(locale))
    router.replace(router.asPath, router.asPath, { locale })
    changeSelectWidth()
  }

  const onToggleCookiesModal = (e) => {
    setShowCookiesModal(!showCookiesModal)
  }

  return (
    <footer className={classNames(styles.footer)}>
      <Container>
        <Row className={styles.itemsContainer} noGutters>
          <Col md={6} className={styles.linksContainer}>
            {(router.pathname.includes('/register') ||
              router.pathname.includes('/federated-id')) && (
              <div className={styles.customSelect}>
                <select
                  id="ga-kp5-footer-language"
                  name="languages"
                  onChange={(e) => onChangeLanguage(e.target.value)}
                  className={classNames(styles.footerItem, styles.languageSelector)}
                  ref={languageSelectorRef}
                >
                  {languageList.map((lang, index) => (
                    <option
                      key={`lang-${index}`}
                      value={lang.value}
                      selected={lang.value === selectedLanguage.toLowerCase()}
                    >
                      {lang.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <Link href="/en/privacy-policy">
              <a target="_blank" className={styles.footerItem}>
                PRIVACY POLICY
              </a>
            </Link>
            {countryRegion === 'EU' && router.pathname.includes('/register') && (
              <>
                <Link href="#">
                  <a
                    aria-hidden
                    onClick={(e) => {
                      e.preventDefault()
                      onToggleCookiesModal()
                    }}
                    className={styles.footerItem}
                  >
                    COOKIES
                  </a>
                </Link>
                <CookieSettingModal
                  show={showCookiesModal}
                  onHide={onToggleCookiesModal}
                  setShow={setShowCookiesModal}
                />
              </>
            )}
            <Link href={`${publicRuntimeConfig.kp4BaseUrl}/legal`}>
              <a className={classNames(styles.footerItem)} target="_blank">
                LEGAL
              </a>
            </Link>
          </Col>
          <Col xs={12} md={4} className={classNames(styles.copyright)}>
            Copyright © 1995-{new Date().getFullYear()} Samsung.{' '}
            {isOnLocalizedPage ? t('All_rights_reserved') : 'All Rights Reserved.'}
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
